import React from "react";
import { Form } from "react-bootstrap";
import { paginationLimitOptionArr } from "../../utilities/const";

const PaginationFilter = ({ setBody, body }) => {
  return (
    <li className="d-flex align-items-center">
      <label htmlFor="" className="form-label m-0 me-1 text-muted">
        Showing
      </label>
      <Form.Select
        aria-label="Default select example"
        className="form-control h-auto fw-sbold text-muted"
        defaultValue={body.limit}
        onChange={(e) =>
          setBody((p) => ({
            ...p,
            limit: +e.target.value,
          }))
        }
      >
        {paginationLimitOptionArr?.map((item) => (
          <option value={item}>{item}</option>
        ))}
      </Form.Select>
    </li>
  );
};

export default PaginationFilter;
